import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import './Gallery.css';

const Gallery = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchGalleries();
  }, []);

  const fetchGalleries = async () => {
    try {
      setLoading(true);
      const response = await apiService.getGalleries();
      setGalleries(response);
    } catch (err) {
      setError('Failed to load gallery');
      console.error('Error fetching galleries:', err);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return (
      <div className='gallery'>
        <div className='gallery-container'>
          <div className='responsive-loading'>
            <div className='responsive-spinner' />
            <p>Loading Gallery...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='gallery'>
        <div className='gallery-container'>
          <div className='error-message'>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='gallery'>
      <div className='gallery-container'>
        <div className='gallery-header'>
          <h1>Our Gallery</h1>
          <p>Moments captured from our journey</p>
        </div>

        <div className='gallery-grid'>
          {galleries.map((item, index) => (
            <div
              key={item.id}
              className='gallery-item'
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className='image-container' onClick={() => openModal(item)}>
                {item.image_url ? (
                  <img
                    src={
                      item.image_url.startsWith('http')
                        ? item.image_url
                        : `${process.env.REACT_APP_API_URL_WITH_OUT_API}${item.image_url}`
                    }
                    alt={item.title || 'Gallery image'}
                    crossOrigin='anonymous'
                  />
                ) : null}
                <div
                  className='image-placeholder'
                  style={{ display: item.image_url ? 'none' : 'flex' }}
                >
                  <i className='fas fa-image'></i>
                </div>
                <div className='image-overlay'>
                  <i className='fas fa-search-plus'></i>
                </div>
              </div>
              {item.title && (
                <div className='gallery-caption'>
                  <h4>{item.title}</h4>
                  {item.description && <p>{item.description}</p>}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className='modal-overlay' onClick={closeModal}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <button className='modal-close' onClick={closeModal}>
              <i className='fas fa-times'></i>
            </button>
            <img
              src={
                selectedImage.image_url.startsWith('http')
                  ? selectedImage.image_url
                  : `${process.env.REACT_APP_API_URL_WITH_OUT_API}${selectedImage.image_url}`
              }
              alt={selectedImage.title || 'Gallery image'}
              crossOrigin='anonymous'
            />
            {selectedImage.title && (
              <div className='modal-caption'>
                <h3>{selectedImage.title}</h3>
                {selectedImage.description && <p>{selectedImage.description}</p>}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
